import { familiesMenuItem } from './constants/menuConstants';

const menuItems = [
  {
    label: 'Home',
    href: '/',
  },
  {
    label: 'Themes',
    href: '/themes',
  },
  {
    label: 'Pricing',
    href: '/pricing',
    plausibleEvent: 'view_pricing',
  },
  {
    label: 'Join your class',
    href: '/student/enrollment',
  },
  {
    label: 'About Us',
    href: '/about',
  },
  familiesMenuItem,
];

export default menuItems;
